<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{item.text}}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">{{ele}}</p>
            <div class="down-btn">立即下载</div>
          </div>
          <div>
            <el-image style="width: 100%; height: 100%" fit='contain' :src="item.rightImage"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 行业分析 start -->
    <div v-if="pageType == 'fenxi'">
      <div class="news-box">
        <p class="news-title">行业分析</p>
        <div class="news-list-item" v-for="(item, index) in fenxiList" :key="index">
          <el-link class="item-link" @click="pageChage('nologin')" :underline="false" type="primary">{{item.title}}</el-link>
          <el-button class="item-btn" type="text" v-for="(ele, index1) in item.btnList" :key="index1" @click="pageChage(ele.type)">[ {{ele.text}} ]</el-button>
        </div>
      </div>
    </div>
    <!-- 行业分析 end -->

    <!-- 技术分享 start -->
    <div v-if="pageType == 'fenxiang'">
      <div class="news-box">
        <p class="news-title">技术分享</p>
        <div class="news-list-item" v-for="(item, index) in fenxiangList" :key="index">
          <el-link class="item-link" @click="pageChage('nologin')" :underline="false" type="primary">{{item.title}}</el-link>
          <el-button class="item-btn" type="text" v-for="(ele, index1) in item.btnList" :key="index1" @click="pageChage(ele.type)">[ {{ele.text}} ]</el-button>
        </div>
      </div>
    </div>
    <!-- 技术分享 end -->

    <!-- 付费资讯 start -->
    <div v-if="pageType == 'pay'">
      <div class="news-box">
        <p class="news-title">付费资讯</p>
        <div class="news-list-item" v-for="(item, index) in payList" :key="index">
          <el-link class="item-link" @click="pageChage('nologin')" :underline="false" type="primary">{{item.title}}</el-link>
          <el-button class="item-btn" type="text" v-for="(ele, index1) in item.btnList" :key="index1" @click="pageChage(ele.type)">[ {{ele.text}} ]</el-button>
        </div>
      </div>

    </div>
    <!-- 付费资讯 end -->

    <!-- 文章列表 start -->
    <div v-if="pageType == 'newslist'">
      <div class="news-box">
        <p class="news-title">文章列表</p>
        <div class="news-list-item" v-for="(item, index) in newsList" :key="index">
          <el-link class="item-link" @click="item.flag ? pageChage('newsdetail') :  pageChage('nologin')" :underline="false" type="primary">{{item.title}}</el-link>
          <el-button class="item-btn" type="text" v-for="(ele, index1) in item.btnList" :key="index1" @click="pageChage(ele.type)">[ {{ele.text}} ]</el-button>
        </div>
      </div>
    </div>
    <!-- 文章列表 end -->

    <!-- 新闻列表 start -->
    <div v-if="pageType == 'newlist'">
      <div class="news-box">
        <p class="news-title">新闻列表</p>
        <div class="news-list-item">
          <el-link class="item-link" @click="pageChage('newsdetail')" :underline="false" type="primary">千名驻村干部打造微营销平台助脱贫</el-link>
          <el-button class="item-btn" type="text" @click="pageChage('')">[ 新闻 ]</el-button>
          <el-button class="item-btn" type="text" @click="pageChage('nologin')">[ 2018-01-08 ]</el-button>
        </div>
      </div>
    </div>
    <!-- 新闻列表 end -->

    <!-- 新闻详情 start -->
    <div v-if="pageType == 'newsdetail'">
      <div class="news-box detail-box">
        <p class="news-title" @click="pageChage('newsdetail')">新闻详情</p>
        <div class="news-list-item-detail">
          <p class="deatil-title">千名驻村干部打造微营销平台助脱贫</p>
          <p class="deatil-tip">发表时间：2018-01-08 11:09</p>
          <p class="deatil-p">
            针对农村土地荒废、劳动力剩余、农民不懂市场等问题，
            广西玉林市福绵区1100多名驻村干部积极发挥“传帮带”作用，组团搭建“福绵善诚”爱心超市微营销平台，
            通过线上和线下帮扶，促进贫困户增收脱贫。
          </p>
          <p class="deatil-p">
            该区组建“福绵善诚”区、镇、村三级爱心微信群，实现政策上传下达、信息共享、
            帮扶销售农副产品等作用；线下布点成立“福绵善诚”爱心超市，组织引导贫困户将农产品放到爱心超市售卖。
            同时，由驻村干部形成116个分片包干小分队进驻固定分点，设置农村e站点平台、设定每月第三个周末定期展销，
            加快线上线下销售。此外，驻村干部和网络科技公司联合组建“福绵善诚”管理队伍，根据市场情况研究农产品需求方向。
            驻村干部们通过财政支持一点、惠民资金整合一点、区代管党费划拨一点、企业老板捐赠一点，
            “四个一点”的方式筹集了1200多万元“福绵善诚”爱心运营基金，用于爱心超市日常运营及打造“福绵善诚”名下特色产业示范带，
            确保了微营销平台资金保障。
          </p>
          <p class="deatil-p">
            据统计，福绵区今年共举办爱心扶贫展销会16场，通过微营销平台销售农产品100多种，
            促进贫困户户均增收1500元以上，帮助26个贫困村2700多户贫困户脱贫致富。
          </p>

        </div>
      </div>
    </div>
    <!-- 新闻详情 end -->

    <!-- 未登录 start -->
    <div v-if="pageType == 'nologin'">
      <div class="news-box">
        <p class="news-title">未登录</p>
        <div class="nologin">
          <div>
            <img src="../assets/imgs/nologin.png">
          </div>
          <p>亲爱的游客，您需要升级到  黄金会员  才能查看文章
            <el-link class="item-link" :underline="false" @click="toLogin" type="primary">登录</el-link>
          </p>
        </div>
      </div>
    </div>
    <!-- 未登录 end -->

    <div class="page" v-if="pageType == 'nologin' && pageType == 'newsdetail'">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="10"
        :total="8">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import banner1 from '@/assets/imgs/banner-1.png';
import banner2 from '@/assets/imgs/banner-2.png';
import banner1r from '@/assets/imgs/banner-1-right.png';
import banner2r from '@/assets/imgs/banner-2-right.png';

export default {
  data () {
    return {
      pageType: '',
      carouselItem: [
        {
          bgcIma: banner1,
          rightImage: banner1r,
          text: '企业OA系统软件',
          list: [
            '●在现办公', '●即时下载', '●会员优惠价：6000元'
          ]
        },
        {
          bgcIma: banner2,
          rightImage: banner2r,
          text: '在线商城软件下载',
          list: [
            '●企业独立运营商城', '●助力企业快速进入移动电商时代', '●会员优惠价：1800元（不含服务器）'
          ]
        }
      ],
      payList: [
        {
          title: '为什么设计师创造的编程语言更受欢迎（4元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-29'},
          ]
        },
        {
          title: '2021年营销人做好微营销必备的9大思维（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-28'},
          ]
        },
        {
          title: 'Windows多线程多任务设计初步（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-14'},
          ]
        },
        {
          title: '在Linux下灵活使用expect脚本的小窍门（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-14'},
          ]
        },
        {
          title: '微营销研讨分享会 助力企业转型电商腾飞（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-11'},
          ]
        },
        {
          title: '关于Linux为什么最多能分4个扇区的解释（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-10'},
          ]
        },
        {
          title: 'PHP开发者常犯的10个MySQL错误（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-09'},
          ]
        },
        {
          title: 'C语言编程程序的内存如何布局（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-08'},
          ]
        }
      ],
      fenxiList: [
        {
          title: '为什么设计师创造的编程语言更受欢迎（4元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-29'},
          ]
        },
        {
          title: '2021年营销人做好微营销必备的9大思维（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-28'},
          ]
        },
        {
          title: '微营销研讨分享会 助力企业转型电商腾飞（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxi', text: '行业分析'},
            {type: 'nologin', text: '2021-07-11'},
          ]
        }
      ],
      fenxiangList: [
        {
          title: 'Windows多线程多任务设计初步（6元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-14'},
          ]
        },
        {
          title: '在Linux下灵活使用expect脚本的小窍门（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-14'},
          ]
        },
        {
          title: '关于Linux为什么最多能分4个扇区的解释（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-10'},
          ]
        },
        {
          title: 'PHP开发者常犯的10个MySQL错误（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-09'},
          ]
        },
        {
          title: 'C语言编程程序的内存如何布局（5元/条）',
          btnList: [
            {type: 'pay', text: '付费资讯'},
            {type: 'fenxiang', text: '技术分享'},
            {type: 'nologin', text: '2021-07-08'},
          ]
        },
      ],
      newsList: []
    }
  },

  created() {
    this.pageType = this.$route.query.type || 'nologin'
    this.newsList = [...this.payList, {
          title: '千名驻村干部打造微营销平台助脱贫',
          flag: true,
          btnList: [
            {type: 'newlist', text: '新闻'},
            {type: 'nologin', text: '2018-01-08'}
          ]
        },]
  },

  methods: {
    pageChage(type) {
      if(type && this.pageType != type) {
         this.pageType = type
        this.$router.push({
          path: '/news',
          query: {
            type
          }
        })
      }
    },
    toLogin() {
      this.$router.push({
          path: '/userlogin'
        })
    }
  },
}
</script>

<style scoped>
 .carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
 }
 .info-box {
   width: 60%;
   height: 70%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   display: flex;
 }
 .info-box div {
   flex: 1;
   color: #fff;
   font-size: 18px;
 }
 .title {
   font-size: 46px;
   padding: 20px 0;
 }
 .info-tip {
   padding: 5px 0;
 }
 .down-btn {
   width: 120px;
   text-align: center;
   padding: 10px 20px;
   border: 1px solid #fff;
   cursor: pointer;
   margin-top: 40px;
 }

.news-box {
  padding: 10px 250px;
}
.news-title {
  color: #009fe9;
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px dotted #b3b3b3;
}
.news-list-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  border-bottom: 1px dotted #b3b3b3;
}
.item-link {
  flex: 9;
  text-align: left;
  justify-content: start;
  padding-left: 10px;
}
.item-btn {
  flex: 1;
}
.page {
  text-align: center;
  padding: 14px 0;
}
.detail-box {
  padding: 30px 250px;
}
.deatil-title {
  font-size: 24px;
  color: #333;
  font-weight: 400;
  padding: 20px;
}
.deatil-tip {
  font-size: 14px;
  color: #adadad;
  padding-left: 20px;
  padding-bottom: 30px;
  border-bottom: 1px dotted #b3b3b3;
  margin-bottom: 20px;
}
.deatil-p {
  text-indent: 2em;
  font-size: 14px;
  color: #676767;
  line-height: 24px;
}

.nologin {
  text-align: center;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue